
import React from 'react';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { AgeGroup } from '@/types/user';

interface AgeGroupSelectorProps {
  selectedAgeGroup: AgeGroup;
  handleAgeGroupChange: (value: string) => void;
  restrictToMinors?: boolean;
}

const AgeGroupSelector = ({ selectedAgeGroup, handleAgeGroupChange, restrictToMinors = false }: AgeGroupSelectorProps) => {
  const ageGroups = restrictToMinors 
    ? [
        { value: '13-and-under', label: '13 and Under', description: 'Parent consent required' },
        { value: '14-17', label: '14-17 Years', description: 'Teen registration' }
      ]
    : [
        { value: '13-and-under', label: '13 and Under', description: 'Parent consent required' },
        { value: '14-17', label: '14-17 Years', description: 'Teen registration' },
        { value: '18-plus', label: '18+ Years', description: 'Adult registration' }
      ];

  return (
    <div className="space-y-3">
      <div className="text-center">
        <Label className="text-lg font-semibold text-white">Select Your Age Group</Label>
        <p className="text-gray-400 text-sm mt-1">Different registration processes apply based on your age</p>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {ageGroups.map((ageGroup) => (
          <div
            key={ageGroup.value}
            className={`p-4 rounded-lg border-2 cursor-pointer transition-all hover:scale-105 ${
              selectedAgeGroup === ageGroup.value
                ? 'border-sports-green bg-sports-green/10'
                : 'border-gray-600 bg-gray-700/50 hover:border-gray-500'
            }`}
            onClick={() => handleAgeGroupChange(ageGroup.value)}
          >
            <div className="text-center">
              <h3 className={`font-bold text-lg ${
                selectedAgeGroup === ageGroup.value ? 'text-sports-green' : 'text-white'
              }`}>
                {ageGroup.label}
              </h3>
              <p className="text-gray-400 text-sm mt-1">{ageGroup.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AgeGroupSelector;
